import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { getInstanceADM } from "../../../../../AdminAPI/InstancesADM";
import fetchModel from "../../../../../AdminAPI/ModelADM";
import {
  applyFilters,
  filterByModel,
} from "../../../../Utils/FiltersManager";
import { applySort } from "../../../../Utils/SortManager";
import { useNavigate } from "react-router-dom";
import "./AdmLotsTable.css";
import NavBar from "../../../../Navbar/Navbar";
import AdmAriane from "../../../../UtilsAdmin/AdmAriane";
import LotStat from "../../../../Dashboard/Default/LotStat/LotStat";
import { parseCustomDate } from "../../../../Utils/DateManager";
import FullTableConfig from "../../AdminFullTableConfig.json";
import "bootstrap/dist/css/bootstrap.min.css";
import { useLotsState } from "../../../../Utils/FiltersManager";
import LotsTableComponent from "../../../../Dashboard/Default/TabLots/LotsTableComponent";

const AdmLotsTable = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [filter, setFilter] = useState(() => {
    const saved = localStorage.getItem("filter_lots");
    return saved ? JSON.parse(saved) : {};
  });

  const [modelName, setModelName] = useState([]);
  const modelId = Cookies.get("modelId");
  const [modelInstanceStatuses, setModelInstanceStatuses] = useState([]);
  const clientId = Cookies.get("clientId");
  const modelIdHome = Cookies.get("modelIdHome");
  const modelNameHome = Cookies.get("modelNameHome");
  const [componentFromCookie, setComponentFromCookie] = useState(
    Cookies.get("modelComponentHome")
  );
  const [config, setconfig] = useState([]);
  const [configKey, setConfigKey] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [viewMode, setViewMode] = useState(
    localStorage.getItem("viewMode") || "client"
  );
  const {
    currentPage,
    setCurrentPage,
    sortField,
    setSortField,
    sortOrder,
    setSortOrder,
    dateRangeFilter,
    setDateRangeFilter,
  } = useLotsState();

  useEffect(() => {
    const setConfigKeyDef = () => {
      let key = "DefaultLots";

      if (
        componentFromCookie &&
        componentFromCookie !== "undefined" &&
        componentFromCookie !== ""
      ) {
        const modelComponentUpperCase =
          componentFromCookie.charAt(0).toUpperCase() +
          componentFromCookie.slice(1);
        key = `${modelComponentUpperCase}Lots`;
      }

      const isClientView = viewMode === "client";

      let fullConfig = [];

      fullConfig = FullTableConfig[key] || [];

      if (fullConfig.length === 0) {
        fullConfig = FullTableConfig["DefaultLots"];
      }

      const filteredConfig = fullConfig.filter((col) => {
        if (isClientView && col.key === "kClientId") return false;
        if (!isClientView && col.key === "sModelId") return false;
        return true;
      });
      setconfig(filteredConfig);
      setConfigKey(key);
    };

    setConfigKeyDef();
  }, [clientId, modelIdHome, componentFromCookie]);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const idToken = Cookies.get("Token");
        let modelData = [];

        if (clientId) {
          modelData = await fetchModel(clientId, idToken);
          setModelName(
            modelData.map((model) => ({
              id: model.ModelId,
              name: model.ModelName,
              component: model.ModelComponent,
            }))
          );
        } else if (componentFromCookie) {
          const modelString = Cookies.get("modelHome");
          modelData = modelString ? [JSON.parse(modelString)] : [];
          setModelName([
            {
              id: modelIdHome,
              name: modelNameHome,
              component: componentFromCookie,
            },
          ]);
        }
        if (modelData && modelData.length > 0) {
          const instanceStatuses = modelData[0].ModelInstanceStatus;
          setModelInstanceStatuses(instanceStatuses);
        }

        let selectedModelId = Cookies.get("modelId");

        if (!selectedModelId && modelData.length === 1) {
          const model = modelData[0];
          selectedModelId = model.ModelId;
          Cookies.set("modelId", selectedModelId);
          Cookies.set("modelIdHome", model.ModelId);
          Cookies.set("modelNameHome", model.ModelName);
          Cookies.set("modelComponentHome", model.ModelComponent);
          setComponentFromCookie(model.ModelComponent);
        } else if (selectedModelId) {
          const selectedModel = modelData.find(
            (m) => m.ModelId === selectedModelId
          );
          if (selectedModel) {
            Cookies.set("modelIdHome", selectedModel.ModelId);
            Cookies.set("modelNameHome", selectedModel.ModelName);
            Cookies.set("modelComponentHome", selectedModel.ModelComponent);
            setComponentFromCookie(selectedModel.ModelComponent);
          }
        }

        const allComponentsUndefined = modelData.every(
          (model) => model.ModelComponent === undefined
        );

        if (modelData.length > 1 && allComponentsUndefined) {
          selectedModelId = undefined;
          Cookies.remove("modelId");
        }

        const responseData = await getInstanceADM(
          clientId,
          selectedModelId,
          idToken
        );
        const extractedData = Array.isArray(responseData)
          ? responseData
          : responseData?.message?.list || [];

        setData(extractedData);
      } catch (error) {
        console.error("Erreur lors du chargement des données", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [clientId, modelIdHome, componentFromCookie, viewMode]);

  useEffect(() => {
    const dataAfterFilters = applyFilters(
      data,
      filter,
      dateRangeFilter,
      parseCustomDate
    );
    const dataAfterModelFilter = filterByModel(dataAfterFilters, filter);
    setFilteredData(dataAfterModelFilter);
  }, [data, filter, dateRangeFilter]);

  const handleConfigKeyChange = (component) => {
    const newConfigKey =
      component.charAt(0).toUpperCase() + component.slice(1) + "Lots";
    setCurrentPage(1);
    setSortField("dCreationDate");
    setSortOrder("desc");

    window.location.href = `/Admin/${newConfigKey}`;
  };

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
      </div>
    );
  }
  const sortedData = applySort(filteredData, sortField, sortOrder);

  return (
    <>
      <NavBar />
      <div className="Ariane_LotStat_style">
        <AdmAriane
          modelName={modelName}
          onChangeConfigKey={handleConfigKeyChange}
        />
        <LotStat
          lots={data}
          onFilterClick={(filterKey) => {
            setFilter((prev) => {
              if (!filterKey) {
                return { ...prev, sStatus: "", filterKey: null };
              }

              return { ...prev, sStatus: filterKey, filterKey: null };
            });
          }}
        />
      </div>

      <LotsTableComponent
        data={data}
        setData={setData}
        modelId={modelId}
        clientId={clientId}
        page="AdmTabLots"
        config={config}
        filter={filter}
        setFilter={setFilter}
        configKey={configKey}
        modelInstanceStatuses={modelInstanceStatuses}
      />
    </>
  );
};

export default AdmLotsTable;
